import { z } from "zod";

export const ChangePasswordResponse = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.object({
        id: z.string().uuid(),
        name: z.string(),
        email: z.string().email(),
        email_verified_at: z.nullable(z.string()), // ISO date string or null
        created_at: z.string(), // ISO date string
        updated_at: z.string(), // ISO date string
        channex_user_api_key: z.nullable(z.string()),
        username: z.nullable(z.string()),
        phone: z.nullable(z.string()),
    }),
});

export type ChangePasswordResponseType = z.infer<typeof ChangePasswordResponse>;